import React from 'react';
import { createMuiTheme } from '@material-ui/core/styles';
import blueGray from '@material-ui/core/colors/blueGrey';
import CssBaseline from '@material-ui/core/CssBaseline';
import deepOrange from "@material-ui/core/colors/deepOrange";
import {useCurrentState} from "./globalState";
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import useTheme from "@material-ui/core/styles/useTheme";

// A theme with custom primary and secondary color.
// It's optional.
const theme = createMuiTheme({
    palette: {
        primary: {
            light: deepOrange[300],
            main: deepOrange[500],
            dark: deepOrange[700],
        },
        secondary: {
            light: blueGray[300],
            main: blueGray[500],
            dark: blueGray[700],
        },
    },
    typography: {
        useNextVariants: true,
    },
});

const themes = {};

function withRoot(Component) {
    function WithRoot(props) {
        // MuiThemeProvider makes the theme available down the React tree
        // thanks to React context.
        let [thm, setThm] = useCurrentState("theme");

        let k = thm.primary.main.substr(1);
        if (!themes[k]) {
            themes[k] = createMuiTheme({
                palette: {
                    primary: {
                        main: thm.primary.main
                    },
                    secondary: {
                        main: thm.primary.main
                    },
                },
                typography: {
                    useNextVariants: true,
                },
            });

        }

        return (
            <ThemeProvider theme={themes[k]}>
                {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                <CssBaseline/>
                <Component {...props} />
            </ThemeProvider>
        );
    }

    return WithRoot;
}

export default withRoot;
